export default  {"src":"/_next/static/image/public/assets/nevo-boi/info.55abf5b878dea15099a46e6e26f8f723.svg","height":22,"width":22};